import { Dispatch } from 'react';
import { CoreApi } from '../../../api/api.apiclient';
import { PageRequest } from '../../../api/api.types';
import { BrokerRateFilters, BrokerRateRequest, EditBrokerRateRequest } from '../../../api/core/core.types';
import {
  DELETE_BROKER_RATE,
  DeleteBrokerRateAction,
  GET_ALL_BROKER_RATES,
  GET_BROKER_RATE,
  GET_BROKER_RATES_LIST, GET_BROKER_RATES_STATISTICS,
  POST_BROKER_RATE,
  PUT_BROKER_RATE,
  UPDATE_BROKER_RATE_FILTERS,
  UpdateBrokerRateFilters
} from '../types/brokerrate.types';

export const getBrokerRateList = (filters?: BrokerRateFilters, page?: PageRequest) => async (dispatch: Dispatch<any>) => {
  const response = await CoreApi.BrokerRates.listAllBrokerRates(filters, page);

  dispatch({
    type: GET_BROKER_RATES_LIST,
    payload: {
      page: response.data
    }
  });
  return Promise.resolve();
};

export const getAllBrokerRatesList = () => async (dispatch: Dispatch<any>) => {
  const response = await CoreApi.BrokerRates.listAllBrokerRatesAllPages(0);

  dispatch({
    type: GET_ALL_BROKER_RATES,
    payload: {
      brokerRates: response
    }
  });
  return Promise.resolve();
};

export const getBrokerRatesStatistics = () => async (dispatch: Dispatch<any>) => {
  const response = await CoreApi.BrokerRates.getBrokerRatesStatistics();

  dispatch({
    type: GET_BROKER_RATES_STATISTICS,
    payload: {
      brokerRatesStatistics: response.data
    }
  });
  return Promise.resolve();
};

export const getBrokerRate = (code: string) => async (dispatch: Dispatch<any>) => {
  try {
    const response = await CoreApi.BrokerRates.getOneBrokerRate(code);

    dispatch({
      type: GET_BROKER_RATE,
      payload: {
        selectedBrokerRate: response.data
      }
    });
  } catch (e) {
    dispatch({
      type: GET_BROKER_RATE,
      payload: {
        selectedBrokerRate: null
      }
    });
  }
};

export const addNewBrokerRate = (request: BrokerRateRequest) => async (dispatch: Dispatch<any>) => {
  const response = await CoreApi.BrokerRates.addNewBrokerRate(request);

  dispatch({
    type: POST_BROKER_RATE,
    payload: {
      success: true,
      newBrokerRate: response.data
    }
  });
};

export const deleteBrokerRate = (code: string) => async (dispatch: Dispatch<DeleteBrokerRateAction>) => {
  await CoreApi.BrokerRates.deleteBrokerRate(code);
  dispatch({
    type: DELETE_BROKER_RATE,
    payload: {
      success: true
    }
  });
};

export const editBrokerRate = (code: string, request: EditBrokerRateRequest) => async (dispatch: Dispatch<any>) => {
  const response = await CoreApi.BrokerRates.editBrokerRate(code, request);

  dispatch({
    type: PUT_BROKER_RATE,
    payload: {
      selectedBrokerRate: response.data
    }
  });
};

export const updateBrokerRateFilters = (filters: BrokerRateFilters) => async (dispatch: Dispatch<UpdateBrokerRateFilters>) => {
  dispatch({
    type: UPDATE_BROKER_RATE_FILTERS,
    payload: {
      filters
    }
  });
};
